var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73585 32.5834C8.7261 36.323 9.59982 40.0121 11.2858 43.3501C13.285 47.35 16.3582 50.7144 20.1614 53.0664C23.9646 55.4183 28.3475 56.665 32.8192 56.6667C36.5588 56.6765 40.2478 55.8028 43.5858 54.1167L59.7358 59.5001L54.3525 43.3501C56.0385 40.0121 56.9123 36.323 56.9025 32.5834C56.9008 28.1117 55.6541 23.7288 53.3021 19.9256C50.9502 16.1225 47.5858 13.0492 43.5858 11.0501C40.2478 9.36405 36.5588 8.49033 32.8192 8.50008H31.4025C25.4969 8.82589 19.9189 11.3186 15.7366 15.5008C11.5543 19.6831 9.06166 25.2611 8.73585 31.1667V32.5834Z",
    fill: "white",
    stroke: "#BC1218",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircle);
export default __webpack_public_path__ + "static/media/message-circle.3b2cce41c58374307c03dd53cbd3383e.svg";
export { ForwardRef as ReactComponent };